<template>
  <div class='title-div'>
    <wc-page-title title='Month View' :subtitle='subtitle' fullWidth></wc-page-title>
    <shift-buttons
      title='This Month'
      dayButton
      weekButton
      :disableToday='disableToday'
      :date='date'
      :showWOs='showWOs'
      :loading='isLoading'
      @clearScheduleData='clearScheduleData'
      @prev='goToPrevMonth'
      @today='goToThisMonth'
      @next='goToNextMonth'
      @deselect="deselect"
      @toggleShowWOs='showWOs = !showWOs'
      @archiveWOs="$emit('archiveWOs')"
    ></shift-buttons>
    <!-- <div class='scroll-container'> -->
      <!-- <div> -->
        <div :class='this.$store.state.nav.showDrawer ? "schedule-container" : "schedule-container-expanded"'>
          <table width='100%' class='monthView'>
            <thead>
              <th v-for='day in 7' :key='day' class='text-center'>
                <span class='body-2 text-uppercase'>{{ getWeekDay(day) }}</span>
              </th>
            </thead>
            <tbody>
              <tr v-for='r in rowsInMonth' :key='r'>
                <td valign='top' :class='getCellClass(getCellDate(r, dIndex))' v-for='(col, dIndex) in 7' :key="r + '_' + dIndex">
                  <div class='caption'>
                    <v-btn
                      tile
                      depressed
                      :color='getDayButtonColor(getCellDate(r, dIndex))'
                      x-small
                      @click="openDayView(getCellDate(r, dIndex))"
                    >
                      {{ getDateDisplay(getCellDate(r, dIndex)) }}
                    </v-btn>
                    <v-btn
                      v-if='isSunday(getCellDate(r, dIndex))'
                      tile
                      depressed
                      dark
                      color='success'
                      x-small
                      @click="openWeekView(getCellDate(r, dIndex))"
                    >Week</v-btn>

                    <div class='mt-2'>
                      <table width='100%'>
                        <tr>
                          <td height='100%' class='schedule-items-box'>
                            <!-- <wc-loading v-if='isLoading' line msg='Loading items...'></wc-loading> -->
                            <route
                              v-for='route in getRoutesForDate(getCellDate(r, dIndex))'
                              :key='route.id'
                              :isLoading='isLoading' 
                              :route='route'
                              :showWOs='showWOs'
                              :showInsertBox='showInsertBox'
                              @getFullRoute='getFullRoute'
                              @select='select'
                              @deselect='deselect'
                              @openCrewVisits='openCrewVisits'
                              @deleteRoute='deleteRoute'
                              @openQuickView='openQuickView'
                              @updateRoute='updateRoute'
                              @moveWOs='moveWOs'
                              @updateWO='updateWO'
                            ></route>
                            <add-route-button
                              :date='getCellDate(r, dIndex)'
                              :schedule='schedule'
                              @addRoute='addRoute'
                            ></add-route-button>
                          </td>
                        </tr>
                      </table>
                    </div>

                  </div>
                </td> 
              </tr>
            </tbody>
          </table>
        </div>
      <!-- </div> -->
    <!-- </div> -->
  </div>
</template>

<script>
import moment from 'moment'
import Route from './Route'
import ShiftButtons from '../../components/ShiftButtons'
import AddRouteButton from './AddRouteButton'

export default {
  name: 'month-view',
  props: {
    isLoading: {
      required: true
    },
    schedule: {
      required: true
    },
    routes: {
      required: true
    },
  },
  data: () => ({
    // For toggling open all routes to see the WOs
    showWOs: false
  }),
  computed: {
    showInsertBox () {
      return this.$store.state.schedule.selectedWOs.length > 0
    },
    date () {
      return moment(this.$route.params.date).format('YYYY-MM-DD').toString()
    },
    today () {
      return moment().format('YYYY-MM-DD').toString()
    },
    nextMonth () {
      return moment(this.$route.params.date).add(1, 'months').format('YYYY-MM-DD').toString()
    },
    prevMonth () {
      return moment(this.$route.params.date).subtract(1, 'months').format('YYYY-MM-DD').toString()
    },
    monthStart () {
      return moment(this.date).startOf('month').format('YYYY-MM-DD').toString()
    },
    monthEnd () {
      return moment(this.date).endOf('month').format('YYYY-MM-DD').toString()
    },
    nextMonthStart () {
      return moment(this.$route.params.date).add(1, 'month').startOf('month').format('YYYY-MM-DD').toString()
    },
    nextMonthEnd () {
      return moment(this.$route.params.date).add(1, 'month').endOf('month').format('YYYY-MM-DD').toString()
    },
    prevMonthStart () {
      return moment(this.$route.params.date).subtract(1, 'month').startOf('month').format('YYYY-MM-DD').toString()
    },
    prevMonthEnd () {
      return moment(this.$route.params.date).subtract(1, 'month').endOf('month').format('YYYY-MM-DD').toString()
    },
    subtitle () {
      return moment(this.date).format('MMMM, YYYY')
    },
    monthStartDayOfWeek () {
      // MomentJS uses Zeri indexed weeks. Sun = 0, Sat = 6
      return moment(this.monthStart).day() + 1
    },
    monthEndDayOfWeek () {
      // MomentJS uses Zeri indexed weeks. Sun = 0, Sat = 6
      return moment(this.monthEnd).day() + 1
    },
    rowsInMonth () {
      // Figures out how many rows the table will need
      let days = this.daysInMonth
      let rowsToAdd = 0
      if (this.monthStartDayOfWeek !== 1) {
        days -= (7 - this.monthStartDayOfWeek)
        rowsToAdd += 1
      }
      if (this.monthEndDayOfWeek !== 7) {
        days -= this.monthEndDayOfWeek 
        rowsToAdd += 1
      }
      return parseInt(days / 7) + rowsToAdd
    },
    daysInMonth () {
      return moment(this.date, 'YYYY-MM').daysInMonth()
    },
    calendarStartDate () {
      // This is the date of the first row, first cell, which
      // is not always the first day of the month (almost never actually)
      let startDate = moment(this.monthStart)
      // We subtract 1 because the days are normally zero indexed, but we're forcing
      // them to be 1 indexed above. The -1 brings it back to zero indexing
      return startDate.subtract(this.monthStartDayOfWeek - 1, 'days').format('YYYY-MM-DD')
    },
    disableToday () {  // disables 'return to this month' button if already on current month.
      return moment(this.date).isSame(this.today, 'month')
    },
    // may need something like this later - keeping in for now.
    // days () {
    //   let daysArray = []
    //   for (let d = 0; d < this.daysInMonth; d++) {
    //     let day = {}
    //     // day.date = this.getCellDate(row, col)
    //     day.routes = this.routes.filter(s => s.date === day.date)
    //     daysArray.push(day)
    //   }
    //   return daysArray
    // }
  },
  mounted () {
    this.$emit('dateChange', this.monthStart, this.monthEnd)
  },
  methods: {
    goToThisMonth () {
      this.$router.push({ name: 'ScheduleMonth', params: { id: this.$route.params.id, date: this.today } })
      this.$emit('dateChange', this.monthStart, this.monthEnd)
      // in this case emit after is the function only to receive new params value for this.today which the function calls
      // (otherwise monthEnd and monthStart are calculating from the old params and not the new date they need)
    },
    goToNextMonth () {
      this.$emit('dateChange', this.nextMonthStart, this.nextMonthEnd)
      this.$router.push({ name: 'ScheduleMonth', params: { id: this.$route.params.id, date: this.nextMonth } })
    },
    goToPrevMonth () {
      this.$emit('dateChange', this.prevMonthStart, this.prevMonthEnd)
      this.$router.push({ name: 'ScheduleMonth', params: { id: this.$route.params.id, date: this.prevMonth } })
    },
    deselectAll () {
      console.log('deselect in month')
    },
    getWeekDay (i) {
      // For display the day of the week at the top of the calendar
      return moment().day(i-1).format('dddd')
    },
    getCellDate (row, col) {
      // Figures out the date required for a specific cell in the table
      let daysToAdd = 0
      row = row - 1
      row = row * 7
      col = col + 1
      daysToAdd = row + col - 1
      return moment(this.calendarStartDate).add(daysToAdd, 'days').format('YYYY-MM-DD').toString()
    },
    getDateDisplay (dt) {
      // For showing the date within a cell, show month too if it's the first
      if (moment(dt).format('D').toString() === "1") {
        return moment(dt).format('MMMM D').toString()
      }
      return moment(dt).format('D').toString()
    },
    getDayButtonColor (dt) {
      return moment(dt, 'YYYY-MM-DD').isSame(moment(), 'day') ? 'info' : 'grey lighten-4'
    },
    getCellClass (dt) {
      // For darkening cells that are not the current month
      let rt = 'dayCell'
      if (moment(dt).isSame(this.monthStart, 'month')) {
        return rt
      }
      return rt + ' wrongMonthBG'
    },
    getRoutesForDate (dt) {
      return this.routes.filter(s => s.date === dt)
    },
    isSunday (dt) {
      // Used to put a "WEEK" button in the Sunday cells
      return moment(dt).day() === 0 ? true : false
    },
    openWeekView (dt) {
      this.$emit('clearScheduleData')
      this.$router.push({ name: 'ScheduleWeek', params: { id: this.$route.params.id, date: dt } })
    },
    openDayView (dt) {
      this.$emit('clearScheduleData')
      this.$router.push({ name: 'ScheduleDay', params: { id: this.$route.params.id, date: dt } })
    },
    addRoute (route) {
      this.$emit('addRoute', route)
    },
    updateRoute (route) {
      this.$emit('updateRoute', route)
    },
    openQuickView (wo) {
      this.$emit('openQuickView', wo)
    },
    deleteRoute (route) {
      this.$emit('deleteRoute', route)
    },
    openCrewVisits (wo) {
      this.$emit('openCrewVisits', wo)
    },
    updateWO (wo) {
      this.$emit('updateWO', wo)
    },
    select (woArray) {
      this.$emit('select', woArray)
    },
    deselect (woArray) {
      this.$emit('deselect', woArray)
    },
    getFullRoute (routeID) {
      this.$emit('getFullRoute', routeID)
    },
    moveWOs (routeID, beforeWoID = 0) {
      this.$emit('moveWOs', routeID, beforeWoID)
    },
    clearScheduleData () {
      this.$emit('clearScheduleData')
    },
  },
  components: {
    'add-route-button': AddRouteButton,
    'shift-buttons': ShiftButtons,
    'route': Route
  }
}
</script>

<style>

table.monthView {
  border-collapse: collapse;
  width: 1500px !important;
}

td.wrongMonthBG {
  background-color: rgba(0,0,0,0.1);
}

td.dayCell {
  border: 1px solid rgba(0,0,0,0.2);
  height: 100px !important;
  width: 220px !important;
}

</style>
